module.exports = __webpack_public_path__ + "7ea21a42.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/670.jpg
// module id = 1333
// module chunks = 0 1